import React from "react";
import { useGame } from "context/gameContext";
import { useRound } from "context/roundContext";
import { classNames, percentageToTailwind } from "utils/utils";
import { SCORES_2ND_HALF } from "utils/constants";
import { useEventPick } from "context/eventPickContext";

const LmsPicks = () => {
  const {
    state: { settings, theme },
  } = useGame();

  const {
    state: { eventData: event, eventPick, isLoading: eventPickLoading },
    dispatch,
  } = useEventPick();

  const {
    state: { currentRound, predictionLeagueRoundData, userRoundData },
  } = useRound();
  let copyrightMode = settings?.copyrightMode;

  const { settled, result, scores, teams } = event || {};

  const homeTeamScore = scores?.find(
    (x) => x.type_id === SCORES_2ND_HALF && x.participant_id === teams?.home?.id
  )?.score?.goals;

  const awayTeamScore = scores?.find(
    (x) => x.type_id === SCORES_2ND_HALF && x.participant_id === teams?.away?.id
  )?.score?.goals;

  //todo: crashes if no users picked any team
  let totalTeamPicks =
    predictionLeagueRoundData?.teams &&
    Object.values(predictionLeagueRoundData?.teams).reduce((a, b) => a + b, 0);
  let homeTeamPicks =
    predictionLeagueRoundData?.teams &&
    predictionLeagueRoundData?.teams[teams?.home?.id]
      ? predictionLeagueRoundData?.teams[teams?.home?.id]
      : "-";

  let awayTeamPicks =
    predictionLeagueRoundData?.teams &&
    predictionLeagueRoundData?.teams[teams?.away?.id]
      ? predictionLeagueRoundData?.teams[teams?.away?.id]
      : "-";

  let homePercentage = percentageToTailwind(
    Math.round((homeTeamPicks / totalTeamPicks) * 100)
  );

  let awayPercentage = percentageToTailwind(
    Math.round((awayTeamPicks / totalTeamPicks) * 100)
  );

  if (eventPickLoading) {
    return "loading";
  }
  return (
    <div className="flex w-full text-sm text-black/80 rounded-r-xl flex-col bg-white pr-2 py-2  justify-center">
      <div className="flex w-full justify-end  pb-0.5 items-center ">
        <div className="px-1 text-xs flex items-center">
          {Math.round((homeTeamPicks / totalTeamPicks) * 100)
            ? Math.round((homeTeamPicks / totalTeamPicks) * 100) + "%"
            : "0%"}
        </div>

        <div
          className={classNames(
            homePercentage,
            awayTeamScore > homeTeamScore
              ? "bg-red-500"
              : awayTeamScore == homeTeamScore
              ? "bg-yellow-500"
              : "bg-customGreen",
            "shadow-sm rounded-md h-3 flex text-xs "
          )}
        ></div>
      </div>
      <div className="flex w-full justify-end  pt-0.5 items-center">
        <div className="px-1 text-xs flex items-center">
          {Math.round((awayTeamPicks / totalTeamPicks) * 100)
            ? Math.round((awayTeamPicks / totalTeamPicks) * 100) + "%"
            : "0%"}
        </div>
        <div
          className={classNames(
            awayPercentage,
            awayTeamScore < homeTeamScore
              ? "bg-red-500"
              : awayTeamScore == homeTeamScore
              ? "bg-yellow-500"
              : "bg-customGreen",
            "shadow-sm rounded-md h-3 flex text-xs"
          )}
        ></div>
      </div>
    </div>
  );
};

export default LmsPicks;
